import { useEffect, useState } from "react";
import redirect1 from "../assets/images/redirect1.png";
import RedirectImage from "../assets/images/redirectImage.png";
import useMediaQuery from "../components/useMediaQuery";
import CylindaLogo from "../assets/images/loading/cylinda-logo.png";
import { useTranslation } from "react-i18next";

export default function VestelIdentity() {
  const isSmallScreen = useMediaQuery("(max-width:785px)");
  const { t, i18n } = useTranslation();
  const [storeUrl, setStoreUrl] = useState(`${process.env.REACT_APP_STORE_URL}customer/login`);

  useEffect(() => {
    setStoreUrl(`${process.env.REACT_APP_STORE_URL}customer/login`);
  }, [i18n.language]);


  return (
    <div className="redirect-page is-cylinda">
      <div className="content-page identity-content-page">
        <div className="redirect-p-title">
          <div>
            <img className="redirect-image redirect-check" src={redirect1} alt="redirect1" />
          </div>
          <p className="redirect-p-center-bold">{t("redirect.toLogInTo")}</p>
          <p className="redirect-p-center-bold">
            {t("redirect.websiteOrApplication")}
          </p>
          <a href={storeUrl} className="redirect-p-center-bold">{t("redirect.click")}.</a>
          {isSmallScreen ? (
            <>
              <div className="sign-in-div">
                <a href={storeUrl}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={CylindaLogo}
                      alt="CylindaLogo"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="sign-in-div">
                <a href={storeUrl}>
                  <div className="sign-in-square">
                    <img
                      className="sign-in-img"
                      src={CylindaLogo}
                      alt="CylindaLogo"
                    />
                    <p className="sign-in-redirect-website">
                      {t("redirect.goToWebsite")}
                      <img src={RedirectImage} alt="redirectImage" />
                    </p>
                  </div>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
